module.exports = __webpack_public_path__ + "img/Tel_Aviv_Universty.1d359a0c.svg";